import React from 'react';

import getConfig from 'next/config';

import { ListingDetails } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';
import { ROUTES } from '@kamernet/core/Routing/routes';

import {
  ListingDetailsContext,
  IListingDetails,
} from './ListingDetailsContext';

const { publicRuntimeConfig } = getConfig();

export const ListingDetailsProvider = ({
  children,
  listingDetails,
}: {
  children: React.ReactNode;
  listingDetails: ListingDetails;
}) => {
  const { locale } = useIntl();

  const value: IListingDetails = React.useMemo(() => {
    const shareTargetURL = `${
      publicRuntimeConfig.ORIGIN
    }${ROUTES.ListingDetails.getURL(
      {
        city: listingDetails.citySlug,
        street: listingDetails.streetSlug,
        listingID: listingDetails.listingId,
        listingType: listingDetails.listingTypeId,
      },
      locale,
      'prefix',
    )}`;

    return {
      shareTargetURL,
      listingDetails,
    };
  }, [listingDetails, locale]);

  return (
    <ListingDetailsContext.Provider value={value}>
      {children}
    </ListingDetailsContext.Provider>
  );
};
